import React from 'react';
import NoSSR from 'react-no-ssr';
import { ChatButton } from '@spotahome/ui-library';
import { trans, getResourcePath } from '@spotahome/bff/client';

import '@spotahome/ui-library/lib/components/ChatButton.css';
import './ZendeskChatButton.scss';

const TIMEOUT = 10000;

const AGENTS_IMAGES = [
  '/images/chat-button/agent_1.jpg',
  '/images/chat-button/agent_2.jpg',
  '/images/chat-button/agent_3.jpg',
  '/images/chat-button/agent_4.jpg',
  '/images/chat-button/agent_5.jpg',
  '/images/chat-button/agent_6.jpg',
  '/images/chat-button/agent_7.jpg',
  '/images/chat-button/agent_8.jpg',
  '/images/chat-button/agent_9.jpg',
  '/images/chat-button/agent_10.jpg',
  '/images/chat-button/agent_11.jpg'
];

const ZendeskChatButton = () => (
  <NoSSR>
    <ChatButton
      buttonText={trans('chat-button.button-text')}
      loadingText={trans('chat-button.loading-text')}
      messageText={trans('chat-button.message-text')}
      className={'zendesk-chat'}
      figures={AGENTS_IMAGES.map(imagePath => getResourcePath(imagePath))}
      timeout={TIMEOUT}
    />
  </NoSSR>
);

export default ZendeskChatButton;
